// Bibliotecas do framework
import React from "react";
import { Link } from "react-router-dom";

// Menu lateral
import { bubble as Menu } from "react-burger-menu";

// Logo
import logo from "../../assets/logo-branca.svg";

export default function Header() {
    return (
        <div className="section">
            <Menu>
                <div className="logo-menu">
                    <img src={logo} className="logo-menu-img" />
                </div>
                
                <Link className="item-menu" to="/home">Home</Link>
                <Link className="item-menu" to="/ferramentas">Ferramentas</Link>
                <Link className="item-menu" to="/materiais">Textos e Outros</Link>
                <Link className="item-menu" to="/historia">História do Priore</Link>
                <Link className="item-menu" to="/agradecimentos">Agradecimentos</Link>
                <Link className="item-menu" to="/contato">Entre em Contato</Link>
                
            </Menu>

            <div className="barra">
                <h2>Priore</h2>
            </div>
        </div>
    );
}